"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const classnames_1 = __importDefault(require("classnames"));
const SimpleCheckbox_1 = __importDefault(require("../styles/SimpleCheckbox"));
exports.default = (0, mobx_react_1.observer)(({ field }) => (react_1.default.createElement("label", { htmlFor: field.id, className: (0, classnames_1.default)(SimpleCheckbox_1.default.label) },
    react_1.default.createElement("input", Object.assign({}, field.bind(), { className: SimpleCheckbox_1.default.input })),
    " ",
    field.label || field.name)));
